import {twMerge} from '@sdox/utils'
import {EnvkvTypeEnum} from '@sdox/api'

import type {ConsumptionValueFragment} from '@sdox/api'
import type {ClassNameValue} from 'tailwind-merge'

export interface BlockConsumptionValuesProps {
  className?: ClassNameValue
  items: ConsumptionValueFragment[]
}

// sorted by definition in Figma: https://www.figma.com/design/Sa93uiAp0RYc7bm9Ov5wan/master?node-id=4689-1148&m=dev
const envkvSortMap: Record<EnvkvTypeEnum, number> = {
  [EnvkvTypeEnum.ConsumptionGas]: 0,
  [EnvkvTypeEnum.ConsumptionGasEmptyBattery]: 1,
  [EnvkvTypeEnum.ConsumptionElectric]: 2,
  [EnvkvTypeEnum.ConsumptionHybrid]: 3,
  [EnvkvTypeEnum.Emission]: 4,
  [EnvkvTypeEnum.Co2Class]: 5,
  [EnvkvTypeEnum.Co2ClassEmptyBattery]: 6,
}
const SORT_PRIO_FOR_UNLISTED_TYPES = Number.POSITIVE_INFINITY
const SEPARATOR = ' • '

export const BlockConsumptionValues = ({className, items}: BlockConsumptionValuesProps) => {
  const text = [...items]
    .sort((a, b) => {
      const prioA: number = envkvSortMap[a.type] ?? SORT_PRIO_FOR_UNLISTED_TYPES
      const prioB: number = envkvSortMap[b.type] ?? SORT_PRIO_FOR_UNLISTED_TYPES
      return prioA - prioB
    })
    .map((item) => `${item.consumptionLabel}: ${item.consumptionValue}`)
    .join(SEPARATOR)

  return (
    <div
      className={twMerge('text-p3 text-glyph-default-secondary', className)}
    >
      {text}
    </div>
  )
}
